module.exports = __webpack_public_path__ + "img/Pulverizador e escadas.99b938d2.webp";